import { Col, Form, Modal, Input, Select, Row } from "antd";
import React, { useEffect, useState } from "react";

import { Severty, ShowToast } from "../helper/toast";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";
import SingleImageUpload from "../components/SingleImageUpload";

const SendMailForm = ({ show, hide, refresh, api }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [image, setImage] = useState();
  const [status, setStatus] = useState();
  const [category, setCategory] = useState();

  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    
  ];

  const handleImage = (data) => {
    data.length > 0 ? setImage(data[0].url) : setImage([]);
  };

  const onSendMail = (values) => {
    console.log(values, "Form Values");
    setLoading(true);

    const payload = {
      ...values,
      image,
    };

    request({
      url: apiPath.sendMail, // API endpoint for sending email
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const getUsers = () => {
    request({
      url:
        apiPath.listTargetedUsers +
        `?category=${category || "mind"}&status=${status}`,
      method: "GET",
      onSuccess: (data) => {
        setUsers(data?.data || []);
      },
      onError: (err) => {
        ShowToast("Something went wrong!", Severty.ERROR);
        console.log(err);
      },
    });
  };

  useEffect(() => {
    if(status && category){
      getUsers();
    }
  }, [status, category]);

  return (
    <Modal
      open={show}
      maskClosable={false}
      width={600}
      okText="Send"
      cancelText="Cancel"
      onCancel={hide}
      okButtonProps={{
        form: "sendMail",
        htmlType: "submit",
        loading: loading,
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
    >
      <Form id="sendMail" form={form} onFinish={onSendMail} layout="vertical">
        <h4 className="modal_title_cls">Send Mail</h4>
        <Row gutter={[16, 0]}>
          {/* Title/Subject */}
          <Col span={24} lg={12}>
            <Form.Item
              label="Title"
              name="title"
              rules={[
                {
                  required: true,
                  message: "Title is required",
                },
                {
                  max: 200,
                  message: "Title should not exceed 200 characters",
                },
                {
                  min: 2,
                  message: "Title should contain at least 2 characters",
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input autoComplete="off" placeholder="Enter Title" />
            </Form.Item>
          </Col>

          {/* Promotion Image or Banner */}
          <Col span={24} lg={12}>
            <Form.Item
              className=""
              // rules={[
              //   {
              //     validator: (_, value) => {
              //       if (value !== undefined && value?.length > 0) {
              //         return Promise.resolve();
              //       }
              //       return Promise.reject(new Error("Image is required"));
              //     },
              //   },
              // ]}
              label={"Upload Image"}
              name="image"
            >
              <SingleImageUpload
                value={image}
                fileType={FileType}
                imageType={"category"}
                btnName={"Image"}
                onChange={(data) => handleImage(data)}
                isDimension={false}
                setLoading={setLoading}
              />
            </Form.Item>
          </Col>

          {/* Description */}
          <Col span={24}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: true,
                  message: "Description is required",
                },
              ]}
            >
              <Input.TextArea
                autoComplete="off"
                rows={5}
                placeholder="Enter Description"
              />
            </Form.Item>
          </Col>

          {/* User Groups */}
          <Col span={24} lg={12}>
            <Form.Item
              label="Group Type"
              name="group"
              rules={[
                {
                  required: true,
                  message: "Please Select User Group",
                },
              ]}
            >
              <Select
                allowClear
                placeholder="Select Group"
                onChange={(value)=>setStatus(value)}
                options={[
                  { label: "Completed", value: "completed" },
                  { label: "Ongoing", value: "current" },
                ]}
              />
            </Form.Item>
          </Col>

          {/* Challenge Category */}
          <Col span={24} lg={12}>
            <Form.Item
              label="Category"
              name="category"
              rules={[
                {
                  required: true,
                  message: "Please Select Category",
                },
              ]}
            >
              <Select
                allowClear
                placeholder="Select Category"
                onChange={(value)=>setCategory(value)}
                options={[
                  { label: "Mind", value: "mind" },
                  { label: "Body", value: "body" },
                  { label: "Spirit", value: "spirit" },
                  { label: "Seasonal", value: "seasonal" },
                ]}
              />
            </Form.Item>
          </Col>

          {/* Users */}
          <Col span={24}>
            <Form.Item
              label="Users"
              name="users"
              rules={[
                {
                  required: true,
                  message: "Please select at least one user",
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                placeholder="Select Users"
                options={users?.map((user) => {
                  return {
                    label:
                      (user?.name?.[0]?.toUpperCase() + user?.name?.slice(1) ||
                        "User") +
                      " (+" +
                      user?.country_code +
                      " " +
                      user?.mobile_number +
                      ")",
                    value: user?._id,
                  };
                })}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default SendMailForm;
